<template>

    <MenuSiCompact/>

    <div class="px-6 surface-overlay relative">

        <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
            <li class="pr-3"><a @click="processHome" class="cursor-pointer"><i class="pi pi-home text-text-900"></i></a>
            </li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Account</a></li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">User Settings</a></li>
        </ul>

        <div style="height: 8px;"></div>

        <div class="grid">
            <div class="col-12">
                <span>
                    Update/view your user settings.
                </span>
            </div>
        </div>

        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div style="height: 20px;"></div>

                    <div class="field">
                        <label for="username">Username</label>
                        <InputText id="username" type="text" :disabled="true" v-model.trim="profile.username"/>
                    </div>

                    <div class="field">
                        <label for="email">Email</label>
                        <InputText id="email" type="text" :disabled="true" v-model.trim="profile.email"/>
                    </div>

                    <div class="field">
                        <label for="mobile">Mobile</label>
                        <InputText id="mobile" type="text" :disabled="true" v-model.trim="profile.mobile"/>
                    </div>

                    <div class="field">
                        <label for="location">Location</label>
                        <Dropdown v-model="userConfiguration.siLocation" :options="locations" :disabled="true"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Region"/>
                    </div>

                    <div class="field">
                        <label for="plan">Plan</label>
                        <Dropdown v-model="userConfiguration.siPlan" :options="plans" :disabled="true"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select an Account Type"/>
                    </div>

                    <div class="field">
                        <label for="siEnableUs">Access to US Stock Market?</label>
                        <Dropdown v-model="userConfiguration.enableSiUs" :options="confirmations" :disabled="true"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div class="field">
                        <label for="siEnableCa">Access to Canadian Stock Market?</label>
                        <Dropdown v-model="userConfiguration.enableSiCa" :options="confirmations" :disabled="true"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div class="field">
                        <label for="siEnableUk">Access to UK Stock Market?</label>
                        <Dropdown v-model="userConfiguration.enableSiUk" :options="confirmations" :disabled="true"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div class="field">
                        <label for="siEnableZa">Access to South African Stock Market?</label>
                        <Dropdown v-model="userConfiguration.enableSiZa" :options="confirmations" :disabled="true"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div class="field">
                        <label for="siEnableUk">Access to SI Course?</label>
                        <InputText id="courseRights" type="text" :disabled="true" v-model.trim="courseRights"/>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <SiFooter/>

</template>

<script>
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import SiFooter from "@/components/heading/authentication/SiFooter.vue";
import ClientService from "@/service/ClientService";
import MenuSiCompact from "@/components/simodule/MenuSiCompact.vue";

export default {
    components: {
        MenuSiCompact,
        SiFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    computed: {
        subscriptionStatusLabel() {
            return this.userConfiguration.siActiveSubscription === "Y"
                ? "Active"
                : "Cancelled";
        }
    },
    async mounted() {
        try {
            // Attempt to get user data
            const userData = await UserService.getUser(this.userStore.user.id);
            this.profile = userData.data;
            console.log("[Configuration][mounted] Data = ", userData);
            console.log("[Configuration][mounted] this.profile = ", this.profile);
        } catch (e) {
            console.error("[Configuration][mounted] Error fetching user data = ", e);
            this.userStore.clearUser();
            // this.$router.push("login");
            this.$router.replace('/siLogin');
            return;
        }

        try {
            const [userConfigData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id)
            ]);

            this.userConfiguration = userConfigData.data;
            console.log("[Configuration][mounted] userConfigData.data = ", userConfigData.data);

            if ((this.profile.rights === 'C') || (this.profile.rights === 'A')) {
                this.courseRights = "Yes"
            } else {
                this.courseRights = "No"
            }

        } catch (e) {
            console.error("[Configuration][mounted] Could not find user config for user = ", this.userStore.user.id);

            if (e.response && e.response.status === 401) {
                console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                // this.$router.push('/siLogin'); // Redirect to the specified login route
                this.$router.replace('/siLogin');
            } else {
                // Handle other errors (e.g., network issues)
                this.userStore.clearUser();
                // this.$router.push('login'); // This is your existing fallback redirect
                this.$router.replace('/siLogin');
            }
            return;
        }

        console.log("[Configuration][mounted] this.userConfiguration = ", this.userConfiguration);
    },
    data() {

        return {
            profile: {},
            submitted: false,
            userConfiguration: {},
            companyConfiguration: {},
            courseRights: "No",
            confirmations: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            plans: [
                {name: 'Monthly', code: 'M'},
                {name: 'Annual', code: 'A'}
            ],
            locations: [
                {name: 'United States', code: 'US'},
                {name: 'Canada', code: 'CA'},
                {name: 'United Kingdom', code: 'UK'},
                {name: 'South Africa', code: 'ZA'},
                {name: 'Other', code: 'O'}
            ],
        }
    },
    methods: {
        closeAllMenus() {
            document.body.click(); // triggers hideOnOutsideClick

            document.querySelectorAll('.p-component-overlay, .p-menu-overlay, .p-overlay, .p-tieredmenu-overlay')
                .forEach(el => el.remove());
        },
        safeNavigate(target) {
            this.closeAllMenus();
            setTimeout(() => {
                this.$router.push(target);
            }, 0);
        },
        processHome() {
            console.log("[MenuConfiguration][processHome] Beginning.");
            this.closeAllMenus();
            this.safeNavigate('/siHome');
        },
        callOverview() {
            this.$router.push("siOverview");
        },
        async processCancellation() {
            this.submitted = true;

            try {
                const response = await ClientService.processCancellationSiClient(this.profile.companyId, this.profile.email);
                console.log("[Configuration][processCancellation] Processed cancellation. Response = [].", response)

                const [userConfigData] = await Promise.all([
                    UserService.getUserConfig(this.userStore.user.id)
                ]);

                this.userConfiguration = userConfigData.data;

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Processed cancellation',
                    life: 3000
                });
            } catch (e) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to process cancellation. Please try again.',
                    life: 3000
                });

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            }

            this.submitted = false;
        },
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
